import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { ContextMenuComponent, ContextMenuModule, ContextMenuService } from '@perfectmemory/ngx-contextmenu';
import { EncFilterField, Encoding, FilterType, VariableType } from '@mode-vegas/vegas';

@Component({
  standalone: true,
  selector: 'mode-flat-table-header-filter-menu',
  imports: [CommonModule, ContextMenuModule],
  templateUrl: './flat-table-header-filter-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlatTableHeaderFilterMenuComponent {
  @Output() action = new EventEmitter<{
    action: 'edit' | 'setDiscrete' | 'setContinuous' | 'remove';
    colId: string;
    colName: string;
  }>();

  @ViewChild(ContextMenuComponent) public menu?: ContextMenuComponent;

  public FilterType = FilterType;
  public variableDiscrete = VariableType.DISCRETE;
  public variableContinuous = VariableType.CONTINUOUS;

  public colId = '';
  public colName = '';
  public field: EncFilterField | null = null;

  constructor(
    private contextMenuService: ContextMenuService,
    private cdr: ChangeDetectorRef
  ) {}

  open(event: MouseEvent, encoding: Encoding | null | undefined, colId: string, colName: string): void {
    this.colId = colId;
    this.colName = colName;
    this.field = encoding?.filter?.find((f) => f.formula === colId) ?? null;

    // OnPush requires explicit change detection so the template
    // re-evaluates [enabled] bindings before the menu renders.
    this.cdr.detectChanges();

    if (!this.menu) return;

    this.contextMenuService.show.next({
      contextMenu: this.menu,
      event,
      item: { colId, colName },
    });
  }

  onEdit(): void {
    if (!this.colId) return;
    this.action.emit({ action: 'edit', colId: this.colId, colName: this.colName });
  }

  onSetDiscrete(): void {
    if (!this.colId) return;
    this.action.emit({ action: 'setDiscrete', colId: this.colId, colName: this.colName });
  }

  onSetContinuous(): void {
    if (!this.colId) return;
    this.action.emit({ action: 'setContinuous', colId: this.colId, colName: this.colName });
  }

  onRemove(): void {
    if (!this.colId) return;
    this.action.emit({ action: 'remove', colId: this.colId, colName: this.colName });
  }
}
